import '@/lib/typedef';
import client from '@/lib/http-client';

const endpoint = '/private-product';

export default {
	getList(params, cb, errorCb) {
		const url = `${endpoint}/list`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getDetail(slug, cb, errorCb) {
		const url = `${endpoint}/${slug}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};

export const getBannerList = (params, cb, errorCb) => {
	const url = `${endpoint}/banner-list`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};
